/**
 * WalkIcon — sanitized from `assets/newSvg/walk.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function WalkIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M11.9999,2 C13.6567,2 14.9999,3.34315 14.9999,5 C14.9999,6.35582174 14.1004285,7.50158382 12.8656975,7.8731619 L12.6953,7.91898 L15.123,10.6935 L16.9471,11.6055 C17.4411,11.8525 17.6413,12.4532 17.3943,12.9472 C17.1649429,13.4058214 16.6306959,13.6112878 16.1600211,13.4405382 L16.0527,13.3944 L14.2286,12.4823 C14.054375,12.395225 13.8941563,12.2832875 13.7527531,12.1503266 L13.6178,12.0105 L12.5997,10.8469 L11.9402,13.485 C11.87836,13.73236 11.772936,13.95732 11.634168,14.153736 L11.524,14.2956 L13.4524,16.0587 C13.7008857,16.2859286 13.8873633,16.5716388 13.9955854,16.8886889 L14.0431,17.0497 L14.7807,20 L14.9999,20 C15.5522,20 15.9999,20.4477 15.9999,21 C15.9999,21.5127571 15.613873,21.9354959 15.1165239,21.9932711 L14.9999,22 L14.078,22 C13.6152667,22 13.2069833,21.7112806 13.0478704,21.285967 L13.0108,21.1667 L12.1028,17.5347 L9.0933,14.7832 C8.32760588,14.3947765 7.88328478,13.5453758 8.02593056,12.6776961 L8.05962,12.5149 L8.5727,10.4626 L8.25039,10.6928 L6.8574,13.0145 C6.57325,13.488 5.95899,13.6416 5.48541,13.3574 C5.04565714,13.0935929 4.8818399,12.5450724 5.08817946,12.0889477 L5.14241,11.9855 L6.53541,9.66381 C6.648338,9.475586 6.7912884,9.3075604 6.95826568,9.16622536 L7.08791,9.06533 L9.85002,7.0924 C9.32392,6.55194 8.99988,5.81381 8.99988,5 C8.99988,3.34315 10.343,2 11.9999,2 Z M9.31613,15.5513 C9.84008,15.7259 10.1232,16.2922 9.94859,16.8162 L9.52324,18.0922 C9.42506,18.3868 9.25964,18.6544 9.04009,18.874 L7.38331,20.5308 C7.58424,20.9088 7.52548,21.3886 7.20701,21.7071 C6.81649,22.0976 6.18332,22.0976 5.7928,21.7071 L5.29987,21.2141 C4.90544,20.8197 4.90544,20.1802 5.29987,19.7858 L7.62587,17.4598 L8.05122,16.1837 C8.22587,15.6598 8.79219,15.3766 9.31613,15.5513 Z"
        fill={color}
      />
    </Svg>
  );
}

export default WalkIcon;
